import React, { FC } from 'react';
import ReactMarkdown from 'react-markdown';

import TraroElement from 'types/api/TraroElement';
import QuestionStatus from 'types/QuestionStatus';

import QuestionStatusButton from 'components/QuestionStatusButton/QuestionStatusButton';
import { useTabsContext } from 'components/Tabs/context/TabsContext';
import Note from 'components/Note/Note';

import './ElementContext.scss';

export interface ElementContextProps {
  traroElement: TraroElement;
  questionStatus: QuestionStatus;
}

const ElementContext: FC<ElementContextProps> = ({ traroElement, questionStatus }) => {
  const { setActiveKey } = useTabsContext();

  return (
    <div className="enkrateia-element-context">
      {traroElement.context0 && traroElement.context0 !== '' && (
        <ReactMarkdown linkTarget="_blank" className="context-0">
          {traroElement.context0}
        </ReactMarkdown>
      )}
      {traroElement.context1 && traroElement.context1 !== '' && (
        <ReactMarkdown linkTarget="_blank" className="context-1">
          {traroElement.context1}
        </ReactMarkdown>
      )}
      {traroElement.context2 && traroElement.context2 !== '' && (
        <Note>
          <ReactMarkdown linkTarget="_blank">{traroElement.context2}</ReactMarkdown>
        </Note>
      )}
      <QuestionStatusButton status={questionStatus} onClick={() => setActiveKey('question')} />
    </div>
  );
};

export default ElementContext;
